var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TableCell',{staticClass:"order-cell",attrs:{"hSpan":1,"data-test":"order-id"}},[_c('OrderId',{attrs:{"orderId":_vm.orderId,"orderIsCanceled":_vm.orderIsCanceled,"orderIsNew":_vm.orderIsNew}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }